import { render, staticRenderFns } from "./ImportItemModal.vue?vue&type=template&id=6ffdb8aa&lang=pug&"
import script from "./ImportItemModal.vue?vue&type=script&lang=ts&"
export * from "./ImportItemModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports